import {configParamsModule} from "../../configParamsModule";

class PermissionGroupAdministrationController {

    filterApi = {};

    constructor() {
    }

}

configParamsModule.controller("permissionGroupAdministrationController", PermissionGroupAdministrationController)